import Error404 from "../components/Error404/Error404"

const NotFound = () => <Error404 />

export default NotFound
